<template>
  <div style="height: 300px; overflow-x:auto">
    <el-row style=" margin-top: 20px;">
      <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="6" style="text-align: right;margin-right: 2%">主机电话：</el-col>
      <el-col :xl="18" :lg="18" :md="18" :sm="18" :xs="13" >
        <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
          <el-switch
            style="display: block;"
            v-model="telephoneNoticeData.hostPhoneVal"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-text="禁用"
            active-text="启用">
          </el-switch>
        </el-col>
        <space-host  v-if="telephoneNoticeData.hostPhoneVal"
                     :type="type"
                     :spaceHostList="spaceHostList"
                     :wholeSpace="wholeSpace"
                     :gatewaySn="gatewaySn"
                     @setWholeSpace="setTelephoneNoticeWholeSpace"
                     @setGatewaySn="setTelephoneNoticeGatewaySn"
                     :spaceList="spaceList"
                     :gatewayList="gatewayList"
                     :hostPhoneData="hostPhoneData"></space-host>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SpaceHost from "@/views/basic_operations/sys_setting/notification_configuration/public_configuration/SpaceHost";

export default {
  name: "TelephoneNotice",
  props:["hostPhoneData","telephoneNoticeData","type","spaceHostList","wholeSpace","gatewaySn","spaceList","gatewayList"],
  components:{SpaceHost},
  // watch:{
  //   wholeSpace(newWholeSpace){
  //     this.$emit("setWholeSpace",newWholeSpace);
  //   },
  //
  //   gatewaySn(newGatewaySn){
  //     this.$emit("setGatewaySn",newGatewaySn);
  //   }
  // },
  methods:{
    setTelephoneNoticeGatewaySn(data){
      this.$emit("setGatewaySn",data);
    },
    setTelephoneNoticeWholeSpace(data){
      this.$emit("setWholeSpace",data);
    }
  }
}
</script>

<style scoped>

</style>
